import { createSlice } from '@reduxjs/toolkit'
import { setNestedKey } from '../../../helpers/common'
import { register } from '../../../helpers/reducerRegistry'
import { TYPE_SCORE } from '../filterSetting/constant'
import {
  convertDataScoreLevelApi,
  dataScoreLevel,
} from '../filterSetting/helper'
import { getFilteredScoreRange } from './thunk'

export const TYPE_LOGICAL_OPERATOR = {
  AND: {
    label: 'AND',
    value: 1,
  },
  OR: {
    label: 'OR',
    value: 2,
  },
  NOT: {
    label: 'NOT',
    value: 0,
  },
}

const initialState = {
  dataScoreLevelRange: {
    1: [],
    2: [],
    3: [],
  },
  typePeriod: {
    label: 'Year',
    value: 1,
  },
  typeScore: {
    label: 'library.filterCompanies.CREDIT_SCORE',
    value: 'creditScore',
    isI18n: true,
  },
  typeScoreBottom: {
    label: 'library.filterCompanies.PERFORMANCE_SCORE',
    value: 'performanceScore',
    isI18n: true,
  },
  logicalOperator: TYPE_LOGICAL_OPERATOR.NOT,
  creditScore: {
    current: {
      fiinGate: {},
      custom: {
        1: { From: undefined, To: undefined },
      },
    },
    previous: {
      fiinGate: {},
      custom: {
        1: { From: undefined, To: undefined },
      },
    },
  },
  performanceScore: {
    current: {
      fiinGate: {},
      custom: {
        1: { From: undefined, To: undefined },
      },
    },
    previous: {
      fiinGate: {},
      custom: {
        1: { From: undefined, To: undefined },
      },
    },
  },
  isLoading: {
    scoreLevel: false,
  },
}

const slice = createSlice({
  name: 'common/filterCompany/scoreLevel',
  initialState,
  reducers: {
    changeTypePeriod: (state, action) => {
      state.typePeriod = action.payload
    },
    changeTypeScore: (state, action) => {
      state.typeScore = action.payload
      state.typeScoreBottom = TYPE_SCORE.find(
        (item) => item.value !== action.payload.value,
      )
    },
    changeTypeScoreBottom: (state, action) => {
      state.typeScoreBottom = action.payload
      state.typeScore = TYPE_SCORE.find(
        (item) => item.value !== action.payload.value,
      )
    },
    changeLogicalOperator: (state, action) => {
      state.logicalOperator = action.payload
    },
    changeCreditScore: (state, action) => {
      const { path, data } = action.payload
      setNestedKey(state.creditScore, path, data)
    },
    changePerformanceScore: (state, action) => {
      const { path, data } = action.payload
      setNestedKey(state.performanceScore, path, data)
    },
    coverDataScoreLevelById: (state, action) => {
      const { creditScore, performanceScore, typePeriod, logicalOperator } =
        convertDataScoreLevelApi(action.payload)
      state.creditScore = creditScore
      state.performanceScore = performanceScore
      state.typePeriod = typePeriod
      state.logicalOperator = logicalOperator
    },
    resetStoreScoreLevel: (state) => {
      Object.keys(initialState).forEach((key) => {
        if (key === 'dataScoreLevelRange') return null
        state[key] = initialState[key]
      })
    },
    resetStoreScoreCredit: (state, action) => {
      if (action.payload) {
        state.creditScore[action.payload] =
          initialState.creditScore[action.payload]
      } else {
        state.creditScore = initialState.creditScore
      }
    },
    resetStoreScorePerformance: (state, action) => {
      if (action.payload) {
        state.performanceScore[action.payload] =
          initialState.performanceScore[action.payload]
      } else {
        state.performanceScore = initialState.performanceScore
      }
    },
  },
  extraReducers: (builder) => {
    //Score Level Range
    builder.addCase(getFilteredScoreRange.pending, (state) => {
      state.isLoading.scoreLevel = true
    })
    builder.addCase(getFilteredScoreRange.fulfilled, (state, action) => {
      state.dataScoreLevelRange = dataScoreLevel(action.payload)
      state.isLoading.scoreLevel = false
    })
    builder.addCase(getFilteredScoreRange.rejected, (state, action) => {
      state.isLoading.scoreLevel = action.payload.loading
    })
  },
})

export const loadingScoreLevel = (state) =>
  state[slice.name].isLoading.scoreLevel

export const selectDataScoreLevelRange = (state) =>
  state[slice.name].dataScoreLevelRange

export const selectTypePeriod = (state) => state[slice.name].typePeriod
export const selectTypeScore = (state) => state[slice.name].typeScore
export const selectTypeScoreBottom = (state) =>
  state[slice.name].typeScoreBottom

export const selectLogicalOperator = (state) =>
  state[slice.name].logicalOperator

export const selectScore =
  (attr = [], callback) =>
  (state) => {
    const data = attr.reduce((result, key) => result[key], state[slice.name])
    return callback ? callback(data) : data
  }

export const {
  changeTypePeriod,
  changeCreditScore,
  changePerformanceScore,
  changeTypeScore,
  resetStoreScoreLevel,
  changeTypeScoreBottom,
  changeLogicalOperator,
  coverDataScoreLevelById,
  resetStoreScoreCredit,
  resetStoreScorePerformance,
} = slice.actions

register(slice.name, slice.reducer)
